import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import Checkbox from '@mui/material/Checkbox'
import dayjs from 'dayjs'
import { hasPermission } from 'hooks/useBackendMenu'
import React from 'react'
import { valoresValeAlimentacao } from 'service/api'
import { axiosInstance } from 'service/api/axios'
import { useStore } from 'store'

const AlterarPagamento: React.FC<GridCellParams> = ({ value, row }) => {
    const empresaId = useStore(state => state.companyId)

    const handleChange = (_: any, checked: boolean) => {
        axiosInstance
            .put('/v1/vale-alimentacao/pagar', {
                empresaId,
                funcionarioId: row.funcionarioId,
                data: dayjs(row.data, 'DD/MM/YY [-] ddd').toDate(),
                pagar: checked,
            })
            .then(async () => {
                await valoresValeAlimentacao.invalidateQueries()
            })
    }

    return (
        <Checkbox
            color="primary"
            onChange={handleChange}
            defaultChecked={value}
            disabled={!hasPermission(['update', 'ValeAlimentação'])}
        />
    )
}

export default AlterarPagamento
